<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
// import Toolbar from 'primevue/toolbar';
import Service from '../../services/movement-instruction';

export default{
  components: { Dialog, Button, DataTable, Column, InputText },
  props: ['item', 'idMovementInstructionHeader', 'reloadMovementInstruction', 'summary', 'submitFn'],
   data(){
    return {
        visible: false,
        selectedHeader: null,
        movementInstructions: [],
        expandedRows: [], 
        voyageNumber: null
    }
   },
   watch: {
        'summary.voyageNumber'(newValue){
            this.voyageNumber = newValue;
        }
   },
   methods: {
    show(){
        this.visible = true;
    },
    hide(){
        this.visible = false;
    },
    searchData(){
         this.movementInstructions = [];
        Service.getSummaryComplete(this.voyageNumber, response => {
            if(response.success){
                this.movementInstructions = [response.data];
            }
        })
    },
    submit(){
        this.submitFn(this.selectedHeader.note);
    },
    exportPdf(item){
        let params = {
            movementInstructionCode: item.code
        };
        this.$store.dispatch("generic/setLoading", true);
        Service.printMovementInstruction(params, response => {
            
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
            
                fileLink.href = fileURL;
                fileLink.setAttribute('download', item.recordData.Code + '.pdf');
                document.body.appendChild(fileLink);
            
                fileLink.click();
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        })
    }
   },
   mounted(){

        
    }
}

</script>

<template>
    <main>
        <Dialog :header="$t('movementInstructions.btn.cloneNote')" v-model:visible="visible" :modal="true" :style="{width: '75vw'}">
            <!-- <Toolbar style="padding: 0;"> -->
                <!-- <template #start> -->
                    <div class="grid formgrid">
                        <div class="col-12 lg:col-3 field">
                            <label for="voyageNumber" :class="{}">{{$t('movementInstructions.voyageNumber')}}</label>
                            <InputText 
                                id="voyageNumber" type="text" 
                                v-model="voyageNumber" 
                                :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                        </div>
                        <!-- TODO - AGGIUNGERE DATE--> 
                        <div class="col-12 lg:col-3 field">
                            <Button :label="$t('btn.search')" icon="pi pi-search" class="p-button-outlined p-button-sm my-5" @click="searchData" />
                        </div>

                    </div>
                <!-- </template> -->
            <!-- </Toolbar> -->
            <DataTable :value="movementInstructions" :reorderableColumns="true" v-model:expandedRows="expandedRows" dataKey="id" showGridlines stripedRows v-model:selection="selectedHeader">
                <Column selectionMode="single" headerStyle="width: 3em" :reorderableColumn="false" ></Column>
                <Column :expander="true" headerStyle="width: 3rem" :reorderableColumn="false"/>
                <Column :exportable="false" :reorderableColumn="false">
                    <template #body="slotProps">
                        <Button icon="pi pi-file-pdf" class="p-button-rounded p-button-outlined" @click="exportPdf(slotProps.data)" />
                    </template>
                </Column>
                <Column field="operationType" :header="$t('operationType.fk')" sortable></Column>
                <Column field="code" :header="$t('code')" sortable></Column>
                <Column field="vessel" :header="$t('movementInstructions.voyageNumber')" sortable></Column>
                <Column field="inspector" :header="$t('inspector.fk')" sortable></Column>
                <Column field="plant" :header="$t('registryPlant.fk')" sortable></Column>
                <Column field="laycanStartDate" :header="$t('movementInstructions.laycanFrom')" sortable></Column>
                <Column field="laycanEndDate" :header="$t('movementInstructions.laycanTo')" sortable></Column>
                <Column field="note" :header="$t('note')" sortable>
                    <template #body="element">
                        <span v-html="element.data.note" />
                    </template>
                </Column>
                <template #expansion="slotProps">
                    <h4>{{$t('movementInstructions.lots')}}</h4>
                    <DataTable :value="slotProps.data.movementInstructionLots" :reorderableColumns="true" >
                        <Column field="company" :header="$t('company.fk')" sortable></Column>
                        <Column field="counterparty" :header="$t('counterparty')" sortable></Column>
                        <Column field="isOutCDep" :header="$t('movementInstructions.isOutCDep')" sortable>
                            <template #body="slotProps">
                                {{ slotProps.data.isOutCDep ? $t('yes') : $t('no')}}
                            </template>
                        </Column>
                        <Column field="incotermCode" :header="$t('incoterm.fk')" sortable></Column>

                        <Column field="originCountry" header="OriginCountry" sortable></Column>
                        <Column field="placeOfLoading" header="PlaceOfLoading" sortable></Column>
                        <Column field="portOrLocationOfLoading" header="PortOrLocationOfLoading" sortable></Column>

                        <Column field="destinationCountry" header="DestinationCountry" sortable></Column>
                        <Column field="placeOfDischarge" header="PlaceOfDischarge" sortable></Column>
                        <Column field="portOrLocationOfDischarge" header="PortOrLocationOfDischarge" sortable></Column>

                        <Column field="product" :header="$t('product.fk')" sortable></Column>
                        <Column field="quantity" :header="$t('movementInstructions.quantity')" sortable></Column>
                        <Column field="minimumQuantity" :header="$t('movementInstructions.minimumQuantity')" sortable></Column>
                        <Column field="maximumQuantity" :header="$t('movementInstructions.maximumQuantity')" sortable></Column>

                    </DataTable>
                </template>
            </DataTable>
             <template #footer>
                <Button :label="$t('btn.cancel')" icon="pi pi-times" @click="visible = false" class="p-button-text"/>
                <Button :label="$t('btn.clone')" icon="pi pi-check" @click="submit" autofocus :disabled="selectedHeader==null"/>
            </template>
        </Dialog>
    </main>
</template>